export enum DistanceUnit {
    METERS = 'meters',
    KILOMETERS = 'kilometers',
}
